module.exports = __webpack_public_path__ + "img/say.aabd951b.png";